import Nav from "./components/Nav";

import Hero from "./components/Hero";
import Clients from "./components/Clients";
import { useEffect } from "react";
import gsap from "gsap";
import Loader from "./components/Loader";
import { loaderGsap } from "./components/animation/loader";
import Skills from "./components/Skills";
import HorizontalScrollSections from "./components/HorizontalScrollSections";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const tl = gsap.timeline();
    loaderGsap(tl);
  }, []);
  return (
    <main className="App max-w-[2000px]  m-auto ">
      <Loader />
      <Nav />
      <Hero />
      <Clients />
      <Skills />
      <HorizontalScrollSections />
      <Contact />
      <Footer />
      <article className="bg-yellow  p-6 px-20 text-center flex justify-between max-sm:flex-col gap-4">
        <h3>Copyright © 2023 @karimelalaoui</h3>
        <h3>All Rights Reserved</h3>
      </article>
    </main>
  );
}

export default App;
